// Team Live metrics row (approved HTML component: team-live-metrics).
import type { ReactNode } from 'react';
import type { TeamLiveMetricsSnapshot } from '../mockData.js';

export interface TeamLiveMetricsProps {
  metrics: TeamLiveMetricsSnapshot;
}

export function TeamLiveMetrics({ metrics }: TeamLiveMetricsProps): ReactNode {
  return (
    <div className="n-metrics" data-component="team-live-metrics">
      <article>
        <span>TEAM TODAY</span>
        <strong>{metrics.creditedSalesToday}</strong>
        <small>{metrics.creditedCaption}</small>
      </article>
      <article>
        <span>AVAILABLE REPS</span>
        <strong>{metrics.availableReps}</strong>
        <small>{metrics.availableCaption}</small>
      </article>
      <article>
        <span>OPEN WORK</span>
        <strong>{metrics.openWork}</strong>
        <small>{metrics.openWorkCaption}</small>
      </article>
      <article>
        <span>EXCEPTIONS</span>
        <strong>{metrics.exceptions}</strong>
        <small>{metrics.exceptionsCaption}</small>
      </article>
    </div>
  );
}
